export default __webpack_public_path__ + "static/GRID22-global-map-es-0c8846a887abf8e27c3b89de8837ef0f.png";